/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Input_File_Not_FoundInputs */

const en_file_input_file_not_found = /** @type {(inputs: File_Input_File_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File not found`)
};

const de_file_input_file_not_found = /** @type {(inputs: File_Input_File_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei nicht gefunden`)
};

/**
* | output |
* | --- |
* | "File not found" |
*
* @param {File_Input_File_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const file_input_file_not_found = /** @type {((inputs?: File_Input_File_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Input_File_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_file_input_file_not_found(inputs)
	return en_file_input_file_not_found(inputs)
});